import React from 'react';

export type Props = { src: string; onEnd?: () => any };

const VideoPlayer = ({ src, onEnd = () => {} }: Props) => {
  const videoRef = React.useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = React.useState(false);

  /**
   * Callback for when video plays
   */
  const onPlaying = () => setIsPlaying(true);

  /**
   * Callback for when video is paused
   */
  const onPause = () => setIsPlaying(false);

  /**
   * Callback for when video ended
   */
  const _onEnd = () => onEnd();

  /**
   * Checks if video is playing
   */
  const playing = () => !videoRef?.current?.paused && isPlaying;

  /**
   * Play
   */
  const play = () =>
    !playing() &&
    videoRef?.current?.play().then(() => {
      onPlaying();
    });

  /**
   * Pause
   */
  const pause = () => playing() && videoRef?.current?.pause();

  const Player = (
    <video ref={videoRef} src={src} muted onPause={onPause} onEnded={_onEnd} />
  );

  return {
    Player,
    play,
    pause,
    isPlaying: playing(),
  };
};

export default VideoPlayer;
